const Loader = () => {
    return(
        <div className="spinnerContainer" style={{marginTop: "200px"}}>
      
        <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    )
}

export default Loader